import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Crosshair } from "lucide-react";
export default function TheCatalystExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="the-catalyst-experts" ref={ref} className="py-20 overflow-hidden relative !text-[hsl(0,0%,0%)] !bg-[hsl(210,16%,93%)] lg:py-28">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: 'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }}>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          
          {}
          <div className="relative w-full max-w-lg mx-auto lg:max-w-none">
            {}
            <div className="relative p-1">
              {}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-primary z-20"></div>
              <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-primary z-20"></div>
              <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-primary z-20"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-primary z-20"></div>

              {}
              
              
              
              {}
              <div className="absolute inset-0 pointer-events-none z-10 border border-primary/10">
                <div className="absolute top-1/2 left-0 w-2 h-[1px] bg-primary/50"></div>
                <div className="absolute top-1/2 right-0 w-2 h-[1px] bg-primary/50"></div>
                <div className="absolute left-1/2 top-0 w-[1px] h-2 bg-primary/50"></div>
                <div className="absolute left-1/2 bottom-0 w-[1px] h-2 bg-primary/50"></div>
              </div>

              {}
              <div className="relative aspect-[4/3] bg-muted overflow-hidden">
                <img src="https://catalystresourcegroupllc.com/wp-content/uploads/2026/03/crgchopt.png" alt="Laboratory technician performing precise assay test on catalyst samples" className="w-full h-full object-cover grayscale-[10%] contrast-[1.05] hover:scale-105 transition-transform duration-700 ease-out" />
                {}
                <div className="absolute inset-0 bg-primary/5 mix-blend-multiply"></div>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center !text-[hsl(0,0%,0%)]">
            <h2 className="text-3xl font-bold mb-6 tracking-tight !text-[hsl(0,0%,0%)] lg:text-4xl">One Call Does It All</h2>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p className="!text-[hsl(0,0%,0%)]">At Catalyst Resource Group, we specialize in helping industrial facilities and refinery operations unlock the hidden value in spent CO catalyst. Our team brings deep industry expertise to what is often a complex disposal challenge, transforming it into a streamlined, profitable recovery opportunity.
              <br /><br /><div>
              </div><div>Spent CO catalysts still contain valuable precious metals. CRG recovers and monetizes that material, providing strong market-based returns that can be applied toward the cost of new catalyst purchases. This turns routine catalyst changeouts into a cost-offsetting recovery opportunity.
              </div><div><br />We give our customers the best price possible for precious metal content.</div><div>
              </div></p>
              
            </div>

            {}
            <div className="mt-10 pt-8 border-t border-border/60">
              <div className="flex flex-col items-start">
                <span className="font-serif italic text-3xl text-primary mb-2">Curt Harke</span>
                <span className="text-xs font-mono uppercase tracking-widest !text-[hsl(210,11%,15%)]">Catalyst Resource Group, LLC
                <br /><br /></span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}